import { createClasses } from '@repo/shared-theme-utils/create-classes'

// --------------------------------------------------------------------------------------------- //

export const scrollbarClasses = {
  root: createClasses('scrollbar__root')
}
